import Vue from "vue";
import Scaffold from "@/Scaffold.vue";

Vue.component("scaffold", Scaffold);
